module.exports = {"210302002":"解放街道","210302003":"山南街道","210302004":"园林街道","210302006":"站前街道","210302008":"和平街道","210302011":"湖南街道","210302013":"新兴街道","210302014":"旧堡街道","210302015":"大孤山街道","210302017":"长甸街道","210302400":"玉佛山风景区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210302.json
// module id = 613
// module chunks = 0